<template>
  <VideoCallRoot
    :theme-mode="roomAppearance.themeMode"
    :call-room="callRoom"
    :event-id="eventId"
    :can-moderate-room="canModerateRoom"
    :is-broadcasting="isBroadcasting"
    :participant-count="participantCount"
    :call-title="callTitle"
    :can-close-manually="canCloseManually"
    :show-call="showCall"
    :is-in-modal="isInModal"
    :show-pop-controls="showPopControls"
    :is-chat-open="isChatOpen"
    :chat-panel-mode="chatPanelMode"
    @close="$emit('close')"
    @pop-out="$emit('pop-out')"
    @pop-in="$emit('pop-in')"
    @toggle-chat="$emit('toggle-chat')"
  >
    <template v-if="$slots['chat-panel']" #chat-panel="panel">
      <slot name="chat-panel" v-bind="panel" />
    </template>
  </VideoCallRoot>
</template>

<script>
import VideoCallRoot from "%/apps/video-engine/components/video-call/VideoCallRoot.vue";
import { RoomAppearanceMixin } from "%/apps/video-engine/room-appearance";
import { mapState } from "pinia";
import { conversationCallRoom, guestConversationCallRoom } from "%/apps/video-engine/call-room";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "VideoCall",
  components: { VideoCallRoot },
  mixins: [RoomAppearanceMixin],
  props: {
    chatPanelMode: {
      type: String,
      default: "push",
    },
    isChatOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
    eventId: {
      type: Number,
      required: false,
      default: 0,
    },
    canModerateRoom: {
      type: Boolean,
      required: false,
      default: false,
    },
    isBroadcasting: {
      type: Boolean,
      required: false,
      default: false,
    },
    conversationId: {
      type: Number,
      required: true,
    },
    canCloseManually: {
      type: Boolean,
      default: true,
    },
    showCall: {
      type: Boolean,
      required: true,
    },
    isInModal: {
      type: Boolean,
      default: false,
    },
    showPopControls: {
      type: Boolean,
      default: true,
    },
    participantCount: {
      type: Number,
      required: false,
      default: 0,
    },
    callTitle: {
      type: String,
      required: false,
      default: "",
    },
  },
  emits: ["close", "pop-out", "pop-in", "toggle-chat"],
  computed: {
    ...mapState(useGeneralStore, ["isLoggedIn"]),
    callRoom() {
      if (!this.conversationId) {
        return null;
      }
      if (!this.isLoggedIn && this.eventId > 0) {
        return guestConversationCallRoom(this.conversationId, this.eventId);
      }

      return conversationCallRoom(this.conversationId);
    },
  },
};
</script>
